import React, { createContext, useContext, useState } from 'react';

const AccessContext = createContext();

export const AccessProvider = ({ children }) => {
  const [allowed, setAllowed] = useState(true);

  const updateAccess = (isAllowed) => {
    //console.log('isAllowed foi alterado para: ', isAllowed ? 'true' : 'false');
    //setAllowed(isAllowed);
    setAllowed(true); //TODO: alterar aqui
  };

  return (
    <AccessContext.Provider value={{ allowed, updateAccess }}>
      {children}
    </AccessContext.Provider>
  );
};

export const useAccess = () => {
  const context = useContext(AccessContext);
  if (!context) {
    throw new Error('useAccess must be used within AccessProvider');
  }
  return context;
};

